import React from 'react';

import {
  AppBar,
  Box,
  Button,
  Divider,
  Grid,
  TablePagination,
  Toolbar,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import EditOutlined from '@material-ui/icons/EditOutlined';
import { useEffect, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import KenGrid from '../../../../global_components/KenGrid';
import KenPopover from '../../../../Components/KenPopOver';
import KenSelectWrap from '../../../../global_components/KenSelect';
import KenDialogBox from '../../../../global_components/KenDialogBox';

import { RiFilterLine, RiCheckFill } from 'react-icons/ri';
import './quetionPaper.css';

import { Message, PictureAsPdf } from '@material-ui/icons';
import PdfImage from '../../../../Assets/pdf-image.png';
import {
  getExamModuleListData,
  getQuestionPaperData,
  postQuestionPaperData,
} from '../../../../Utils/apiServices';
import KenLoader from '../../../../Components/KenLoader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TablePaginationActions from '../../../../global_components/KenGrid/TablePaginationActions';
import SamplePdf from '../../../../Assets/samplePdf.pdf';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useTranslation } from 'react-i18next';
const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'Question Paper',
  },
];

const ActionCellSendMessage = (row) => {
  const history = useHistory();
  const { id } = row.row.values;

  const handleClick = () => {
    history.push(`/app/exam/questionPaper/chat-history/${id}`);
  };

  return (
    <Message
      style={{
        color: '#092682',
      }}
      className="m-0"
      onClick={handleClick}
    />
  );
};

const CellWithButton = (row) => {
  const classes = useStyles();
  const { status } = row.row.values;

  let classOfBtn;
  if (status === 'Not Submitted') {
    classOfBtn = classes.errorText;
  } else if (status === 'Submitted') {
    classOfBtn = classes.submittedText;
  } else if (status === 'Under Review') {
    classOfBtn = classes.underReviewText;
  } else {
    classOfBtn = classes.approvedText;
  }

  return (
    <Box>
      <Button
        size="small"
        variant="primary"
        // component={Link}
        className={classOfBtn}
        // to={`${routes.currentCoursemes}/${id}/details`}
      >
        {status}
      </Button>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    color: theme.palette.KenColors.primary,
    padding: '0',
    backgroundColor: '#fff',
    marginBottom: '10px',
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'uppercase',
    paddingLeft: '10px',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    height: '28px',
    width: '78px',
    textDecoration: 'none',
    textTransform: 'none',
    // '&:hover': {
    //   color: 'pink',
    //   borderBottom: '1px solid pink',
    // },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    background: 'orange',
    borderRadius: '25px',
    fontSize: '10px',
    margin: '5px  5px',
    color: 'white',
    height: '23px',
    '&:hover': {
      color: 'white',
      background: 'orange',
    },
    // color: '#FFF',
    // background: '#EB5757',
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // '&:hover': {
    //   color: 'white',
    //   background: '#be6f6f',
    //   borderBottom: '1px solid #be6f6f',
    // },
  },
  normal: {
    color: 'white',
    width: '100px',
    background: 'green',

    borderRadius: '10px',
    fontSize: '12px',
    height: '35px',

    margin: '5px 5px',
    '&:hover': {
      background: 'green',

      color: 'white',
    },
    // color: '#FFF',
    // background: '#27AE60',
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // '&:hover': {
    //   color: 'white',
    //   background: '#84e2ac',
    //   borderBottom: '1px solid #84e2ac',
    // },
  },
  view: {
    width: '100px',
    color: 'white',

    background: '#55b0cd',

    borderRadius: '10px',
    fontSize: '12px',
    height: '35px',

    margin: '5px 5px',
    '&:hover': {
      background: '#55b0cd',

      color: 'white',
    },
    // color: '#FFF',
    // background: '##272727',
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // '&:hover': {
    //   color: 'white',
    //   background: 'grey',
    //   borderBottom: '1px solid grey',
    // },
  },
  review: {
    color: '#f17100',
    background: 'rgba(255, 196, 10,0.2)',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    height: '23px',

    '&:hover': {
      background: 'rgba(255, 196, 10,0.2)',
      color: '#f17100',
    },
    // color: '#FFF',
    // background: '#F2994A',
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // '&:hover': {
    //   color: 'white',
    //   background: '#dab391',
    //   borderBottom: '1px solid #dab391',

    //#dab391
  },
  errorText: {
    color: '#F14B2D',
    fontSize: '12px',
  },
  submittedText: {
    fontSize: '12px',
    color: '#27AE60',
  },
  underReviewText: {
    fontSize: '12px',
    color: '#F2994A',
  },
  approvedText: {
    fontSize: '12px',
    color: '##272727',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      fontWeight: 500,
      padding: '9px',
    },
    '&  table thead tr th ': {
      fontWeight: 500,
      padding: '9px',
      background: '#FFFFFF',
      color: '#061938',
    },
  },
}));

const selectOptionsCourse = [
  {
    label: 'Select Course',
    value: '',
  },
  {
    label: 'BBAECO103-Macroeconomics',
    value: 'BBAECO103-Macroeconomics',
  },
];

const selectOptionsStatus = [
  {
    label: 'Select Campus',
    value: '',
  },
  {
    label: 'Approved',
    value: 'Approved',
  },
  {
    label: 'Request Sent',
    value: 'Request Sent',
  },
  {
    label: 'Submitted',
    value: 'Submitted',
  },
  {
    label: 'Under Review',
    value: 'Under review',
  },
];

const selectOptionsTerm = [
  {
    label: 'Select Component',
    value: '',
  },
  {
    label: 'MACRO TERM 1',
    value: 'MACRO TERM 1',
  },
];

const selectOptionsFaculty = [
  {
    label: 'Select Faculty',
    value: '',
  },
  {
    label: 'Ganesh',
    value: 'Ganesh',
  },
];

const ActionCell = ({ row, onApproveStatus }) => {
  const classes = useStyles();
  const { status } = row.row.values;
  const history = useHistory();
  const id = row.row.original.id;
  console.log('ididid', id);

  const handleClickView = () => {
    history.push(`/app/exam/questionPaper/question-paper-view/${id}`);
  };

  // View Modal
  const [viewDialog, setViewDialog] = useState(false);
  // const [first, setfirst] = useState(false);
  function handleViewDialog() {
    setViewDialog((prevState) => !prevState);
  }

  const handleClick = () => {
    handleViewDialog();
  };

  const onApproveQuestionPaper = () => {
    console.log('row.row.original.id', row.row.original);

    if (
      row.row.original.setOneStatus === 'Approved' &&
      row.row.original.setTwoStatus === 'Approved'
    ) {
      const payload = [
        {
          id: row.row.original.id,
          status: 'Approved',
          sendEmail: false,
        },
      ];

      postQuestionPaperData(payload)
        .then((res) => {
          onApproveStatus();
        })
        .catch((err) => {
          alert('Failed to add. Please try again.');
        });
      // setfirst(true);
    } else {
      toast.error('Question-paper is not apporved ', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  // useEffect(() => {
  //   onApproveQuestionPaper();
  // }, [first]);

  return (
    <Box>
      {(status === 'Approved' ||
        status === 'Under review' ||
        status === 'Submitted' ||
        status === 'Request Sent') && (
        <Button
          className={classes.view}
          size="small"
          variant="primary"
          // component={Link}
          onClick={() => {
            handleClickView();
          }}
          // to={`${routes.questionPaperView}`}
        >
          View
        </Button>
      )}
      {(status === 'Request Sent' ||
        status === 'Under review' ||
        status === 'Submitted') && (
        <>
          <Button
            className={classes.normal}
            size="small"
            variant="primary"
            onClick={() => onApproveQuestionPaper()}
            // value={}
          >
            Approve
          </Button>
          {/* <Button
            className={classes.review}
            size="small"
            variant="primary"
            component={Link}
            // to={`${routes.currentProgrammes}/${id}/details`}
          >
            Review
          </Button> */}
        </>
      )}
      {/* {(status === 'Request Sent' ||
        status === 'Under review' ||
        status === 'Submitted') && (
        <Button
          className={classes.error}
          size="small"
          variant="primary"
          // to={`${routes.currentProgrammes}/${id}/details`}
        >
          Remind
        </Button>
      )} */}
      {/* Question Paper Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            View Question Paper
          </Typography>
        }
        open={viewDialog}
        handleClose={() => handleViewDialog()}
        negativeButtonClick={() => handleViewDialog()}
        positiveButtonClick={() => handleViewDialog()}
        hideNegativeButton={true}
        hidePositiveButton={true}
        dividers
      >
        <Grid
          xs={12}
          alignItems="center"
          justifyContent="space-between"
          container
        >
          <Typography variant="h6" className={classes.dialogHeader}>
            Course:{' '}
          </Typography>

          <Typography variant="p" className={classes.dialogHeader}>
            UX/UI Design
          </Typography>
        </Grid>
        <Divider />

        <Grid
          xs={12}
          alignItems="center"
          justifyContent="space-between"
          container
        >
          <Typography variant="h6" className={classes.dialogHeader}>
            Faculty:{' '}
          </Typography>
          <Typography variant="p" className={classes.dialogHeader}>
            Nandhini Clament
          </Typography>
        </Grid>
        <Divider />

        <Grid
          xs={12}
          alignItems="center"
          justifyContent="space-between"
          container
        >
          <Typography variant="h6" className={classes.dialogHeader}>
            Term:{' '}
          </Typography>
          <Typography variant="p" className={classes.dialogHeader}>
            Term II
          </Typography>
        </Grid>
        <Divider />

        <Typography
          variant="h6"
          className={classes.dialogHeader}
          style={{ fontSize: '58px', margin: '25px' }}
        >
          <img src={PdfImage} alt="pdf" />
        </Typography>
      </KenDialogBox>
    </Box>
  );
};

const selectOptionsBatch = [
  {
    label: 'Select Batch',
    value: '',
  },
  {
    label: 'February',
    value: 'February',
  },
  {
    label: 'April',
    value: 'April',
  },
  {
    label: 'October',
    value: 'October',
  },
  {
    label: 'December',
    value: 'December',
  },
];

const QuestionPaper = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterDialog, setFilterDialog] = useState(false);
  const [questionData, setquestionData] = useState([]);
  const [rows, setRows] = useState([]);
  const [totalData, setTotalData] = useState(25);
  // Filter State
  const [filterData, setFilterData] = useState();
  const [examMonthData, setExamMonthData] = useState([]);
  const [selectCourseData, setselectCourseData] = useState([]);
  const [selectTermData, setselectTermData] = useState([]);
  const [selectCampusData, setselectCampusData] = useState([]);
  const [selectFacultyData, setselectFacultyData] = useState([]);
  const [selectFacultyData1, setselectFacultyData1] = useState([]);

  const [loading, setLoading] = React.useState(false);
  const columns = [
    // {
    //   Header: 'id',
    //   accessor: 'id',
    //   disableGlobalFilter: true,
    // },
    {
      Header: 'COURSE NAME',
      accessor: 'courseName',
      disableGlobalFilter: true,
    },
    {
      Header: 'TERM',
      accessor: 'term',
      disableGlobalFilter: true,
    },
    {
      Header: 'FACULTY',
      accessor: 'faculty',
      disableGlobalFilter: true,
    },
    {
      Header: 'Exam Cycle',
      accessor: 'examCycle',
      disableGlobalFilter: true,
    },
    {
      Header: 'BATCH',
      accessor: 'batch',
      disableGlobalFilter: true,
    },

    {
      Header: 'STATUS',
      accessor: 'status',
      disableGlobalFilter: true,
      Cell: CellWithButton,
    },
    {
      Header: 'ACTIONS',
      accessor: 'actions',
      disableGlobalFilter: true,
      Cell: (row) => (
        <ActionCell row={row} onApproveStatus={getQuestionPaperDatas} />
      ),
    },
    // {
    //   Header: 'CHAT HISTORY',
    //   accessor: 'chatHistory',
    //   disableGlobalFilter: true,
    //   Cell: ActionCellSendMessage,
    // },
  ];

  const [selectValueCourse, setSelectValueCourse] = useState(
    selectOptionsCourse[0].value
  );
  const handleSelectChangeCourse = (e) => {
    setSelectValueCourse(e.target.value);
  };

  const [selectValueStatus, setSelectValueStatus] = useState(
    selectOptionsStatus[0].value
  );
  const handleSelectChangeStatus = (e) => {
    setSelectValueStatus(e.target.value);
  };

  const [selectValueTerm, setSelectValueTerm] = useState(
    selectOptionsTerm[0].value
  );
  const handleSelectChangeTerm = (e) => {
    setSelectValueTerm(e.target.value);
    setSelectValueCourse('');
  };

  const [selectValueFaculty, setSelectValueFaculty] = useState(
    selectOptionsFaculty[0].value
  );
  const handleSelectChangeFaculty = (e) => {
    setSelectValueFaculty(e.target.value);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [selectValueBatch1, setSelectValueBatch1] = useState([]);
  const [selectValueBatch, setSelectValueBatch] = useState('');
  const handleSelectChangeBatch = (e) => {
    setSelectValueBatch(e.target.value);
  };
  const [selectValueExamCycle1, setSelectValueExamCycle1] = useState([]);

  const [selectValueExamCycle, setSelectValueExamCycle] = useState('');
  const handleSelectChangeExamCycle = (e) => {
    setSelectValueExamCycle(e.target.value);
  };

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onApproveQuestionPaper = () => {
    console.log('object');
    const newData = [...questionData];

    const payload = newData.map((row) => {
      return {
        id: row.id,
        status: row.status,
      };
    });

    postQuestionPaperData(payload)
      .then((res) => {
        getQuestionPaperDatas();
      })
      .catch((err) => {
        alert('Failed to add. Please try again.');
      });
  };

  useEffect(() => {
    getExamModuleListData().then((res) => {
      setFilterData(res);
    });
  }, []);

  useEffect(() => {
    let TermListData = filterData?.TermList.map((item) => {
      return {
        label: item.TermName,
        value: item.TermName,
      };
    });
    setselectTermData(TermListData);

    // For Course
    let CourseListData = filterData?.CourseList.filter((item) => {
      return (
        selectValueTerm == item.TermName && item.TermName && item.CourseName
      );
    }).map((item) => {
      return {
        label: item.CourseName,
        value: item.CourseName,
      };
    });

    setselectCourseData(CourseListData);

    // For Faculty
    let FacultyListData = filterData?.courseFacultyList
      .filter((item) => {
        console.log('item---Fac', item);
        return selectValueCourse === item.CourseName;
      })
      .map((itemss) => {
        let Fcaulty = itemss?.FacultyName?.map((item) => {
          return {
            label: item,
            value: item,
          };
        });

        return Fcaulty;
        // setselectFacultyData1(Fcaulty);
      });
    setselectFacultyData(FacultyListData);

    //For Campus
    let CampusListData = filterData?.campus.map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setselectCampusData(CampusListData);

    let BatchListData = filterData?.batchList
      .filter((item) => {
        return item != null;
      })
      .map((item) => {
        return {
          label: item,
          value: item,
        };
      });
    setSelectValueBatch1(BatchListData);

    let ExamCycleListData = filterData?.ExamMonthList.filter((item) => {
      return item != null;
    }).map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setSelectValueExamCycle1(ExamCycleListData);
  }, [filterData, selectValueTerm, selectValueCourse]);

  // useEffect(() => {
  //   // For Faculty

  // }, [filterData, selectValueCourse]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getQuestionPaperDatas = () => {
    setLoading(true);
    let filterData = {
      course: selectValueCourse,
      status: selectValueStatus,
      term: selectValueTerm,
      faculty: selectValueFaculty,
      batch: selectValueBatch,
      examCycle: selectValueExamCycle,
    };
    getQuestionPaperData(filterData).then((res) => {
      console.log('resForStudentStatus', res);
      setLoading(false);
      const QuestionPaperInfo =
        res === null
          ? []
          : res?.questionPapersList.map((item, index) => {
              console.log('itemitem', item);
              return {
                id: item.id,
                courseName: item.courseName ? item.courseName : 'NA',
                term: item.term ? item.term : 'NA',
                faculty: item.faculty ? item.faculty : 'NA',
                status: item.status ? item.status : 'NA',
                batch: item.batch ? item.batch : '',
                examCycle: item.examCycle ? item.examCycle : '',
                setOneStatus: item.setOneStatus ? item.setOneStatus : '',
                setTwoStatus: item.setTwoStatus ? item.setTwoStatus : '',
              };
            });
      setLoading(false);
      setTotalData(res.noOfRecords);
      setquestionData(QuestionPaperInfo);
      setFilterDialog(false);
    });
  };
  useEffect(() => {
    getQuestionPaperDatas();
  }, []);

  return (
    <Box>
      {loading && <KenLoader />}
      <ToastContainer />
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Question Paper
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            {/* <Button
              startIcon={<GetAppIcon />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
            >
              <a href={SamplePdf} style={{textDecoration:'none',color:"white"}} download>
              {t("labels:Report")}
              </a>
            </Button> */}
            <Button
              startIcon={<RiFilterLine />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleFilterDialog}
            >
              Filter
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>
      <Box className={`${classes.gridKenClass} cardlsitbox`}>
        <KenCard elevation={0}>
          <KenGrid
            columns={columns}
            data={questionData}
            pagination={{ disabled: true }}
            toolbarDisabled={true}
            gridProps={{
              getCellProps: (row) => {
                if (row.column.Header === 'CHAT HISTORY') {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
              getHeaderProps: (column) => {
                if (column.Header === 'CHAT HISTORY') {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
            }}
          />{' '}
          <Box style={{ display: 'flex', justifyContent: 'right' }}>
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              colSpan={6}
              count={totalData ? totalData : questionData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Box>
        </KenCard>
      </Box>
      {/* Filter Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            FILTER
          </Typography>
        }
        icon={<RiCheckFill />}
        open={filterDialog}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleFilterDialog()}
        positiveButtonClick={() => getQuestionPaperDatas()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Term"
              options={selectTermData}
              value={selectValueTerm}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeTerm}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Course"
              options={selectCourseData}
              value={selectValueCourse}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCourse}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Faculty"
              options={selectFacultyData?.[0]}
              value={selectValueFaculty}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeFaculty}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Batch"
              options={selectValueBatch1}
              value={selectValueBatch}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeBatch}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Exam Cycle"
              options={selectValueExamCycle1}
              value={selectValueExamCycle}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeExamCycle}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Status"
              options={selectOptionsStatus}
              value={selectValueStatus}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeStatus}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>
    </Box>
  );
};

export default QuestionPaper;
